<p-toast></p-toast>
<p-confirmDialog rejectButtonStyleClass="p-button-outlined"> </p-confirmDialog>
<div class="changeControlDetails" *ngIf="isChangeControlDetailsAccessible; else loadErrorPage">
  <app-top-bar [topBarTitle]="topBarTitle"></app-top-bar>
  <div class="changeControlDetailsContainer">
    <div class="columns toolbar">
      <div class="column1">
      <div 
        class="overflow-ellipsis"
        tooltipPosition="bottom"
        pTooltip="{{ changeControlDisplayDetails.number }} {{
          changeControlDisplayDetails.title
        }}"
        tooltipStyleClass="tooltip"
      >
        <app-label
          class="changeControlNumber"
          labelText="{{ changeControlDisplayDetails.number }} "
        ></app-label>
        <app-label
          class="changeControlTitle"
          labelText="{{ changeControlDisplayDetails.title }}"
        ></app-label>
      </div>
      </div>
      <div class="column2">
        <div class="btn" 
        *ngIf="changeControlDisplayDetails.changeControlAuthorizationFlags.isReviewButtonAvailable">
          <p-button
            appPreventDoubleClick
            pTooltip="Review Status"
            tooltipPosition="left"
            icon="fas fa-eye"
            id="ccReviewStatusButton"
            iconPos="left"
            (debounceClick)="openTransactionModal()"
          ></p-button>
        </div>
        <div class="btn" 
        *ngIf="changeControlDisplayDetails.changeControlAuthorizationFlags.isApprovalButtonAvailable">
          <p-button
            appPreventDoubleClick
            pTooltip="Approval Status"
            tooltipPosition="left"
            icon="fas fa-check-circle"
            id="ccApprovalStatusButton"
            iconPos="left"
            (debounceClick)="openTransactionModal()"
          ></p-button>
        </div><div class="btn" 
        *ngIf="changeControlDisplayDetails.changeControlAuthorizationFlags.isVerificationButtonAvailable">
          <p-button
            appPreventDoubleClick
            pTooltip="Verification Status"
            tooltipPosition="left"
            icon="fas fa-check"
            id="ccVerificationStatusButton"
            iconPos="left"
            (debounceClick)="openTransactionModal()"
          ></p-button>
        </div>
        <div class="btn" *ngIf="changeControlDisplayDetails.changeControlAuthorizationFlags.isEditButtonAvailable">
          <app-edit-button (openSlider)="openSlider()"></app-edit-button>
        </div>
        <div  class="btn" *ngIf="changeControlDisplayDetails.changeControlAuthorizationFlags.isNextPhaseButtonAvailable">
          <app-next-phase 
          (isNextPhaseModalVisible)="moveToNextPhase()"
        ></app-next-phase>
        </div>
        <div class="btn" *ngIf="changeControlDisplayDetails.changeControlAuthorizationFlags.isPreviousButtonAvailable">
          <app-previous-phase
          (isPreviousPhaseModalVisible)="displayReasonForChangeModalOnClick($event)"
          ></app-previous-phase>
        </div>
        <div class="btn">
          <p-button
            appPreventDoubleClick
            pTooltip="Export to PDF"
            tooltipPosition="left"
            icon="fas fa-file-pdf"
            id="ccExportToPDFButton"
            iconPos="left"
            (debounceClick)="exportToPDF()"
            styleClass="p-button-outlined"
          ></p-button>
        </div>

       <div class="btn" 
        *ngIf="changeControlDisplayDetails.changeControlAuthorizationFlags.isVoidedButtonAvailable">
          <p-button
            appPreventDoubleClick
            pTooltip="Void Change Control"
            tooltipPosition="left"
            icon="fas fa-ban"
            id="ccVoidedStatusButton"
            iconPos="left"
            (debounceClick)="openReasonForVoidPopUp()"
            styleClass="p-button-outlined"
          ></p-button>
        </div>
      </div>
    </div>

    <div class="bpt-main-content-container" style="overflow-y: auto">
      <p-tabView [(activeIndex)]="activeIndex">
        <p-tabPanel header="General">
          <app-change-control-general-details
            [changeControlDisplayDetails]="changeControlDisplayDetails"
          ></app-change-control-general-details>
        </p-tabPanel>
        <p-tabPanel header="Action Plan">
          <app-action-plan [changeControlNumber] = "changeControlNumber" 
          [isAddButtonVisible] = "changeControlDisplayDetails.changeControlAuthorizationFlags.isAddActionItemButtonAvailable"
          [scopes] = "changeControlDisplayDetails.eQMSScopes"
          (selectedItems)="getSelectedActionItems($event)"
          ></app-action-plan>
        </p-tabPanel>
        <p-tabPanel header="Audit Trail"> 
          <app-change-control-audit-trial [number] = "changeControlNumber" *ngIf="activeIndex === 2" ></app-change-control-audit-trial>
        </p-tabPanel>
      </p-tabView>
    </div>
  </div>
</div>

<div *ngIf="isReasonForChangeModal">
  <app-change-control-previous-phase-modal
    [changeControlNumber]="changeControlNumber"
    [requiredModalHeader]="previousPhaseModalHeader"
    (isReasonForChangeModalVisible)="closeReasonForChangeModal($event)"
    (updatedChangeControlData)="UpdateChangeControlDetail($event)"
    >
  </app-change-control-previous-phase-modal>
</div>
<div *ngIf="isTransactionModal">
  <app-change-control-phase-update-by-phaseOwners
    [changeControlDetails] = "changeControlDisplayDetails"
    (isTransactionModalVisible)="closeTransactionModal($event)"
    (updateChangeControlDispalyDetails)="updateChangeControlDetailsOnTransaction($event)">
  </app-change-control-phase-update-by-phaseOwners>
</div>
<app-change-control-slider *ngIf="isChangeControlSliderOpen"
[isChangeControlSliderOpen]="isChangeControlSliderOpen"
(isChangeControlSliderActive)="closeChangeControlSlider($event)"
[changeControlDetails]="changeControlDisplayDetails"
(changeControlDataReload)="intialize()"
></app-change-control-slider>

<app-dialog *ngIf="showCCVoidReasonPopUp" 
[heading]="headingForMoveCCToVoidedPhase"
(saveDocumentwithReason)="moveCCToVoidedPhase($event)" 
[reasonValidationMessage]="validationMessageForReasonForMovingCCToVoided"
(isModelOpen)="closeReasonDailog($event)">  
</app-dialog>


<ng-template #loadErrorPage>
  <app-error [errorMessage]="pageLoadErrorMessage"></app-error>
</ng-template>
